import styled from './login.module.css';
import { CiUser, CiLock, CiRead, CiUnread,CiRedo } from 'react-icons/ci';
import {FaSpinner} from 'react-icons/fa';
import { useContext, useEffect, useState } from 'react';
import { onlynumber,Alerta } from '../../utils/functions';
import { AuthContext } from '../../services/global';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import {toast} from 'react-toastify';




function Login() {
    const [ver, setVer] = useState(false);
    const [cgccli, setCgccli] = useState('');
    const [sencli, setSencli] = useState('');
    const {setLogado,setStatus,setCgcglobal,setCodcli} = useContext(AuthContext);
    const Navigate = useNavigate();

    const [loading,setLoading] = useState(false);

    //Controle de status para acesso ao primerio acesso**************
    function PrimeiroAcesso() {
        setStatus('acesso');
        Navigate('/Acesso');
    }
    //*************************************************************** */
    
    function EsqueciSenha() {
        setStatus('esqueci');
        Navigate('/Esqueci');
    }
    
    
    //Funcao de autenticacao na api*********************************************
    async function Autentica() {
        localStorage.removeItem('login');
        setLoading(true);
        await api.get(`autentica/?cgccli=${cgccli}&sencli=${sencli}`)
            .then((response) => {
                if (!response.data.msg){
                    localStorage.setItem("login", JSON.stringify(response.data));
                    const login = JSON.parse(localStorage.getItem("login"));
                    toast.success('Seja bem vindo !!! '+login.nomcli);
                    setCgcglobal(login.cgccli);
                    setCodcli(login.codcli)
                    setLogado(true);
                    setLoading(false);
                    Navigate('/Main');
                }else{
                    setLogado(false);
                    Alerta('Falha!',response.data.msg,'error');
                    setLoading(false);
                }
                
            }).catch((erro) => {
                setLogado(false);
                Alerta('Erro!','Erro de acesso ao sistema! '+erro,'error');
                setLoading(false);
            })
    }
    //***************************************************************************

    useEffect(() => {
        setStatus(''); //Sempre que carregar login zera status
        setCgccli('');
        setSencli('');
        setCgcglobal(''); //Sempre que carregar login zera cgc global
        localStorage.removeItem('login');
    },[])

    return (
            <div className={styled.pagelogin}>
                <div className={styled.container}>
                    <div className={styled.logo}>
                        <div className={styled.logoimg}></div>
                    </div>
                    <div className={styled.formlogin}>
                        <div className={styled.formheader}>
                            <div className={styled.titleheader}>
                                <a className={styled.titletext}>Portal do Cliente</a>
                                <div className={styled.titletextline}></div>
                            </div>
                        </div>
                        <div className={styled.formcontent}>
                            <div className={styled.apploginform}>
                                <div className={styled.applogininputs}>
                                    <div className={styled.fielduser}>
                                        <CiUser className={styled.fieldusericon} />
                                        <input type='text' placeholder='Cnpj' value={cgccli} onChange={(e) => setCgccli(e.target.value)} />
                                    </div>
                                    <div className={styled.fieldpass}>
                                        <CiLock className={styled.fieldusericon} />
                                        {ver === false ?
                                            <input type='password' placeholder='Senha' value={sencli} onChange={(e) => setSencli(e.target.value)} />
                                            :
                                            <input type='text' placeholder='Senha' value={sencli} onChange={(e) => setSencli(e.target.value)} />
                                        }
                                        {ver === false ?
                                            <CiUnread onClick={() => setVer(true)} size={24} />
                                            :
                                            <CiRead onClick={() => setVer(false)} size={24} />
                                        }

                                    </div>
                                    <div className={styled.btnesqueci}>
                                        <a onClick={()=>EsqueciSenha()}>Esqueci minha senha</a>
                                    </div>
                                </div>
                                <div className={styled.apploginbtn}>
                                    <button disabled={loading} className={styled.btnentrar} onClick={()=>Autentica()} >
                                        {loading==true ? 'AUTENTICANDO...' : 'ENTRAR'}  
                                        
                                    </button>
                                    <button onClick={() => PrimeiroAcesso()} className={styled.btnacesso} >PRIMEIRO ACESSO</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styled.logo}>
                        <div className={styled.logoimg2}></div>
                    </div>
                </div>
            </div>

    )
}


export default Login;